/** The public application has one address on the website, Admin and the sign-in surface. */
export const HOST_PROGRAM_PATH = '/startnow';
const legacyPath = '/host-program/aaron';
export function isHostProgramPath(pathname) {
    const path = pathname.replace(/\/$/, '');
    return path === HOST_PROGRAM_PATH || path === legacyPath;
}
/** Preserve verification fragments and sign-in parameters from links already issued. */
export function canonicalHostProgramUrl(location) {
    return location.pathname !== HOST_PROGRAM_PATH && isHostProgramPath(location.pathname)
        ? HOST_PROGRAM_PATH + location.search + location.hash
        : null;
}
//# sourceMappingURL=hostProgramPath.js.map